/**@file api.config.js
 */

exports.Url = {
    osReportUrl: '/smp/mapplog/log',
    // 开源打点
    userInfoUrl: '/community/api/user_info',
    // 帖子相关接口，editTopic 用于用户修改已发表帖子的请求
    topicListUrl: '/community/api/topic_list',
    topicContentUrl: '/community/api/topic_detail',
    delTopicUrl: '/community/api/topic_del',
    addTopicUrl: '/community/api/topic_add',
    updateTopicUrl: '/community/api/topic_update',
    addTopicSourceUrl: '/community/api/topic_editpage',
    editTopicUrl: '/community/api/topic_editpage',
    // 帖子回复相关接口
    delReplyUrl: '/community/api/reply_del',
    addReplyUrl: '/community/api/reply_add',
    replyListUrl: '/community/api/reply_list1',
    replyListUrlTwo: '/community/api/reply_list2',
    // 上传资源接口
    uploadImgUrl: '/community/api/tools_imgupload',
    uploadFileUrl: '/community/api/tools_fileupload',
    officialSupporterListUrl: '/community/api/official_supporterlist',
    // 跟进人员接口
    changeOfficialFollowerUrl: '/community/api/official_followset',
    // 签约宿主列表接口,待修改
    officialAuthorListUrl: '/community/api/official_authorlist',
    // 创建 icafe 链接
    officialicafeaddUrl: '/community/api/official_icafeadd',
    // 帖子状态变更
    officialProcessUpdate: '/community/api/official_processupdate',
    // 退出登录
    userLogout: '/osc/user/logout',
};
